export const PRESET_CATEGORIES = {
  FIBER: 'Fiber (Item1)',
  POLYMER: 'Polymer (Item2)'
};
